import React, { useState } from 'react';

import { ILink } from '../../../../../../types/contentful';

import { NavItem } from '../../../shared';

import {
  CategoryContainer,
  NavLinkContainer,
  NavLink,
  CaretWrapper,
  Caret,
  SublinkContainer,
  Sublink,
  SublinkList,
  SublinkItem
} from '../MobileNav.styles';

import downArrow from '@/images/arrow-down.svg';

export function ModalNavCategory({
  name,
  title,
  url,
  links,
  isExpanded
}: NavItem) {
  const [expanded, setExpanded] = useState(isExpanded);
  const [rotated, setRotated] = useState(isExpanded as boolean);

  const toggleCategoryDisplay = (
    e: React.MouseEvent<HTMLElement, MouseEvent>
  ) => {
    if (links) {
      e.preventDefault();
    }

    setExpanded(!expanded);
    setRotated(!rotated);
  };

  return (
    <CategoryContainer>
      <NavLinkContainer>
        <NavLink
          aria-controls={`nav-expanded-content-${name}`}
          aria-expanded={expanded}
          href={links ? '#0' : (url as string)}
          onClick={toggleCategoryDisplay}
        >
          {name || title}
          {links && (
            <CaretWrapper>
              <Caret alt="caret" src={downArrow} rotated={rotated} />
            </CaretWrapper>
          )}
        </NavLink>
      </NavLinkContainer>
      <SublinkContainer id={`nav-expanded-content-${name}`} expanded={expanded}>
        <SublinkList>
          {links &&
            links.map(({ fields }: ILink, idx: number) => (
              <SublinkItem key={fields?.title ?? idx}>
                <Sublink href={fields?.url}>{fields?.title}</Sublink>
              </SublinkItem>
            ))}
        </SublinkList>
      </SublinkContainer>
    </CategoryContainer>
  );
}
